const CACHE = {
  countries: []
}

export const setCountryOptions = countries => {
  CACHE.countries = countries;
}

export const getCountryOptions = () => {
  return CACHE.countries
}

const rawStates = [
  "AK",
  "AL",
  "AR",
  "AS",
  "AZ",
  "CA",
  "CO",
  "CT",
  "DC",
  "DE",
  "FL",
  "FM",
  "GA",
  "GU",
  "HI",
  "IA",
  "ID",
  "IL",
  "IN",
  "KS",
  "KY",
  "LA",
  "MA",
  "ME",
  "MD",
  "MH",
  "MI",
  "MN",
  "MO",
  "MS",
  "MT",
  "NC",
  "ND",
  "NE",
  "NH",
  "NJ",
  "NM",
  "NV",
  "NY",
  "MP",
  "OH",
  "OK",
  "OR",
  "PA",
  "PR",
  "PW",
  "RI",
  "SC",
  "SD",
  "TX",
  "TN",
  "UT",
  "VA",
  "VI",
  "VT",
  "WA",
  "WI",
  "WV",
  "WY"
]

const inflate = () => rawStates.map(state => ({value: state, label: state}))
const inflated = inflate()

export const stateOptions = inflated

const STATE_ABBR = process.env.STATE_ABBR

export const filteredStateOptions = inflated.filter(({value}) => value !== STATE_ABBR)

export const getStateOptions = () => {
  return stateOptions
}



// WEBPACK FOOTER //
// ./src/components/Wizard2/selectOptions.js